export default __webpack_public_path__ + "static/media/target.46655c5e.svg";